import { createContext, useContext } from 'react';
import type { ViewRenderCapability } from './viewRender';

export type ReportError = (error: Error, context: Record<string, unknown>) => void;

export interface ViewerEnvironment {
  /** Where a failure goes beyond the console, e.g. Datadog. */
  readonly onError?: ReportError;
  /** Where overlays and tooltips render, e.g. inside the shadow root that holds their styles. */
  readonly portalContainer?: HTMLElement | null;
  /** Offers an AI render of the view wherever the full viewer is shown. */
  readonly viewRender?: ViewRenderCapability;
}

export const ViewerEnvironmentContext = createContext<ViewerEnvironment>({});

export const useViewerEnvironment = (): ViewerEnvironment => useContext(ViewerEnvironmentContext);

export const usePortalContainer = (): HTMLElement => useViewerEnvironment().portalContainer ?? document.body;
